import { __rest } from "tslib";
import React from 'react';
import { st, classes } from './text-extended.st.css';
import cssVars from '../styles/css-vars.scss';
export const TextExtended = (props) => (React.createElement(TextExtendedNoUseApi, Object.assign({}, props, { mobile: props.isMobile })));
export const TextExtendedNoUseApi = (_a) => {
    var { className, priority = 'primary', typography = 'content', dataHook, mobile, size, tag } = _a, props = __rest(_a, ["className", "priority", "typography", "dataHook", "mobile", "size", "tag"]);
    const Component = (tag !== null && tag !== void 0 ? tag : 'span');
    return (React.createElement(Component, Object.assign({ className: st(classes.root, { priority, typography, mobile, size: size || typography }, cssVars.reactionsContainer, className), "data-hook": dataHook }, props)));
};
//# sourceMappingURL=text-extended.js.map